import { render, staticRenderFns } from "./AnswerMultiple.vue?vue&type=template&id=d7157e90&scoped=true"
import script from "./AnswerMultiple.vue?vue&type=script&lang=ts"
export * from "./AnswerMultiple.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7157e90",
  null
  
)

export default component.exports